import { Component, OnInit } from '@angular/core';
import { Icon } from '../icon';

@Component({
  selector: 'iconmonstr-arrow-right',
  templateUrl: './arrow-right.component.html',
})
export class ArrowRightComponent extends Icon {
}
